// DataComponent.tsx
import { useEffect, useState } from 'react';
import { useDataContext } from './Contexts/DataContext';
import { ComboBox, Item, Key } from '@adobe/react-spectrum';
import { DataComponentProps } from './DataComponentProps';

interface ProjectDropDownProps extends DataComponentProps {
    parent_folder_id?: number;
    activity_type_id?: number;
}
const ProjectDropDown: React.FC<ProjectDropDownProps> = ({ 
  parent_folder_id,
  activity_type_id,
  compKey, 
  label, 
  width, 
  isRequired, 
  onValueChange,
  value: dvalue
}) => {
  const message = `${label} is required`;
  const [errorMessage, setErrorMessage] = useState(isRequired && !dvalue? message : '');  
  const [value, setValue] = useState<Key | null>('');
  const [input, setInput] = useState('');
  const { getProjectData } = useDataContext();
  const { data, error, loading } = getProjectData({ parent_folder_id, activity_type_id });

  useEffect(() => {
    if(dvalue && dvalue != 'undefined') {
        setValue(dvalue);
    }
  },[dvalue]);
  
  const onSelectionChange = (value: Key | null) => {
    if(onValueChange)
        onValueChange(value ? value.toString() : '', input);
    setValue(value);
    if(isRequired && !value && !input) {
      setErrorMessage(message);
    } else 
      setErrorMessage('');
  };

  const onInputChange = (_value: string) => {
    setInput(_value);
    if(isRequired && !_value) {
      setErrorMessage(message);
    } else 
      setErrorMessage('');    
  }
  
  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;

  return (
    <ComboBox key={compKey} 
        label={label} 
        width={width} 
        isRequired={isRequired} 
        selectedKey={value}
        onSelectionChange={onSelectionChange} 
        onInputChange={onInputChange}
        validationState={errorMessage ? 'invalid' : undefined}
        errorMessage={errorMessage}
        >
      {data.map((item) => (
        <Item key={item.id} textValue={item.title}>
          {item.title}
        </Item>
      ))}
    </ComboBox>
  );
};

export default ProjectDropDown;
